import {
  ErrorComponent,
  type ErrorComponentProps,
  Link,
  useRouter,
} from '@tanstack/react-router'
import { Button } from '~/components/ui/button'

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
  const router = useRouter()

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center gap-4 p-8">
      <ErrorComponent error={error} />
      <div className="flex gap-2">
        <Button
          onClick={() => router.invalidate()}
          variant="outline"
        >
          Retry
        </Button>
        <Button asChild variant="default">
          <Link to="/">Go Home</Link>
        </Button>
      </div>
    </div>
  )
}
